import React, { PureComponent } from 'react'
import { View, Platform } from 'react-native'

import styled from 'styled-components/native'

import theme from '../../../styles/theme'

import { Text } from '../../Atoms/Typography'
import Spinner from '../../Atoms/Spinner'
import Button from '../Button'
import Modal from '../Modal'

const ModalContainer = styled(View)`
  flex: 1;
  justify-content: center;
  align-items: center;
`
const ModalBody = styled(View)`
  padding: ${2 * theme.gutterUnit}px;
  justify-content: center;
  background-color: ${theme.colours.white};
  width: 500px;
  border-radius: 5px;
  border: solid 1px ${theme.colours.lightgrey};
`

const ActionRow = styled(View)`
  marginTop: ${2 * theme.gutterUnit}px;
  flexDirection: row;
  justify-content: flex-end;
`

class Alert extends PureComponent {
  render () {
    const { visible, onConfirm, onCancel, cancelLabel = 'CANCEL', confirmLabel = 'OK', children, cancelInProgress, confirmInProgress } = this.props
    return (
      <Modal
        isVisible={visible}
        visible={visible}
        onBackdropPress={onCancel}
        ariaHideApp={false}
        transparent={Platform.select({ web: false, default: true })}
        backdropColor='black'
        backdropOpacity={0.75}
      >
        <ModalContainer>
          <ModalBody>
            {children}
            <ActionRow>
              {(onCancel) ? (
                <Button
                  colour={theme.colours.grey}
                  noborder
                  onPress={onCancel}
                  rounded
                  styles={[{ width: 90, marginRight: theme.gutterUnit }]}
                >
                  {cancelInProgress ? <Spinner colour={theme.colours.black} /> : <Text>{cancelLabel}</Text>}
                </Button>
              ) : (null)}
              {(onConfirm) ? (
                <Button
                  colour={theme.colours.blue}
                  noborder
                  onPress={onConfirm}
                  rounded
                  styles={[{ width: 90, padding: theme.gutterUnit }]}
                >
                  {confirmInProgress ? <Spinner white /> : <Text white>{confirmLabel}</Text>}
                </Button>
              ) : (null)}
            </ActionRow>
          </ModalBody>
        </ModalContainer>
      </Modal>
    )
  }
}

export default Alert
